import React from 'react'
import Fragment from '../common/fragment'


function FragmentDO(props) {
  return (
    <Fragment pos="oooo" {...props}>
      <p>
Maximiliano enferma en Salamanca y es curado con sanguijuelas. Vuelve a
enfermar en una ciudad cercana, pero las sanguijuelas locales no lo sanan. Mandan
a pedir algunas a Salamanca. El emperador se recupera. Sus súbditos están felices
por los resultados. Confían en su aire imperial y en la eficacia de esos insectos
oscuros. La sangre.
      </p>
    </Fragment>
  )
}


export default FragmentDO
